import { Model, ModelCollection } from './hydra';
import {
  CharacteristicIdealMultiple,
  CharacteristicMultiple,
  CharacteristicSingle
} from './characteristics';
import { Picture } from './picture';
import { UserFavorite } from './userFavorite';
import { Subscription } from './sub';

export const WANTED_LOVE = 'love';
export const WANTED_FRIEND = 'friend';
export const WANTED_SEX = 'sex';

export const STATUS_BOT         = 'bot';
export const STATUS_ACTIVE      = 'active';
export const STATUS_MODERATED   = 'moderated';
export const STATUS_SUSPENDED   = 'suspended';
export const STATUS_DELETED     = 'deleted';
export const STATUS_LOCKED      = 'locked';

export const SUBSCRIPTION_BRANCHE = 'ROLE_USER_BRANCHE';
export const SUBSCRIPTION_GEEK    = 'ROLE_USER_GEEK';

export const GENDER_HE = 'il';
export const GENDER_SHE = 'elle';
export const GENDER_THEY = 'iel';

export type Gender = typeof GENDER_HE | typeof GENDER_SHE | typeof GENDER_THEY;
export type Wanted = typeof WANTED_LOVE | typeof WANTED_FRIEND | typeof WANTED_SEX;
export type SubscriptionType = typeof SUBSCRIPTION_BRANCHE | typeof SUBSCRIPTION_GEEK;

interface CommonCharacteristics {
  situation: CharacteristicSingle & CharacteristicIdealMultiple;
  living: CharacteristicMultiple & CharacteristicIdealMultiple;
  silhouette: CharacteristicMultiple & CharacteristicIdealMultiple;
  eyeColor: CharacteristicSingle & CharacteristicIdealMultiple;
  hairsColor: CharacteristicSingle & CharacteristicIdealMultiple;
  hairsLength: CharacteristicSingle & CharacteristicIdealMultiple;
  style: CharacteristicMultiple & CharacteristicIdealMultiple;
  values: CharacteristicMultiple & CharacteristicIdealMultiple;
  children: CharacteristicSingle & CharacteristicIdealMultiple;
  eats: CharacteristicMultiple & CharacteristicIdealMultiple;
  smoking: CharacteristicSingle & CharacteristicIdealMultiple;
  alcohol: CharacteristicSingle & CharacteristicIdealMultiple;
  pets: CharacteristicSingle & CharacteristicIdealMultiple;
  hobbies: CharacteristicMultiple & CharacteristicIdealMultiple;
  schoolLevel: CharacteristicSingle & CharacteristicIdealMultiple;
  wage: CharacteristicSingle & CharacteristicIdealMultiple;
  sexualPractices: CharacteristicMultiple & CharacteristicIdealMultiple;
  ethnicGroups: CharacteristicMultiple & CharacteristicIdealMultiple;
}

interface MyCharacteristics {
  height: number;
  childrenInfos: string;
  job: string;
  weight: number;
}

interface IdealCharacteristics {
  idealAgeMin: number;
  idealAgeMax: number;
  idealWeightMin: number;
  idealWeightMax: number;
  idealHeightMin: number;
  idealHeightMax: number;
  idealZodiacSign: string[] | null;
}

export interface User
  extends Model,
    CommonCharacteristics,
    MyCharacteristics,
    IdealCharacteristics {
  '@type': 'User';
  code: string;
  username: string;
  displayName: string;
  pictures: Picture[];
  profilePicture: Picture | null;
  gender: Gender;
  wantedGender: Gender;
  wanted_gender: Gender[];
  email: string;
  age: number;
  ageHidden: boolean,
  zodiacSign: {
    sign: string;
  };
  address: {
    city: string;
  };
  myExpectations: string;
  favorites: UserFavorite[];
  wanted: Array<string>;
  notificationMailTopics: Array<string>;
  notificationPushTopics: Array<string>;
  distance: number;
  searchDistance: number;
  isLocalized: boolean;
  allowLocalization: boolean;
  isOnline: boolean;
  isLocked?: boolean;
  isAdmin?: boolean;
  hasLocked?: boolean;
  lastSeen: string | null;
  isFavorite?: boolean;
  hasAccessRequest: boolean;
  lastVisit?: Date;
  addedToState?: boolean;
  status: string;
  isTyping: boolean;
  debug: boolean;
  subscription?: SubscriptionType | boolean | null;
  subscriptions: Subscription[];
}

export type UserCollection = ModelCollection<User>;

export interface AuthenticatedUser extends User {
  '@id': string;
  id: string;
  username: string;
  phoneNumber: string;
  phoneCode: string;
  address: {
    city: string;
    country: string;
    label: string;
    geoPoint: {
      latitude: number;
      longitude: number;
    };
  };
  roles: string[];
  permissions: { [key: string]: boolean };
  invisibleSince: string;
  fullyInvisibleSince: string;
  createdAt: string;
}

export interface HasOwner {
  owner: User;
}
